export interface SpeechBubbleEntry {
  readonly key: string;
  readonly text: string;
  readonly expiresAtMs: number;
}

const MAX_TEXT_LENGTH = 90;
const BASE_DURATION_MS = 2800;
const EXTRA_MS_PER_CHARACTER = 35;

const entries = new Map<string, SpeechBubbleEntry>();
const listeners = new Set<() => void>();

function notifyListeners(): void {
  for (const listener of listeners) {
    listener();
  }
}

export function showSpeechBubble(key: string, text: string): void {
  const trimmedKey = key.trim();
  const trimmedText = text.trim();
  if (!trimmedKey || !trimmedText) {
    return;
  }
  const normalizedText = trimmedText.length > MAX_TEXT_LENGTH
    ? `${trimmedText.slice(0, MAX_TEXT_LENGTH - 1)}...`
    : trimmedText;
  const durationMs = BASE_DURATION_MS + normalizedText.length * EXTRA_MS_PER_CHARACTER;
  entries.set(trimmedKey, {
    key: trimmedKey,
    text: normalizedText,
    expiresAtMs: performance.now() + durationMs,
  });
  notifyListeners();
}

export function getSpeechBubble(key: string, nowMs = performance.now()): SpeechBubbleEntry | null {
  const entry = entries.get(key);
  if (!entry) {
    return null;
  }
  if (entry.expiresAtMs <= nowMs) {
    entries.delete(key);
    notifyListeners();
    return null;
  }
  return entry;
}

export function hasActiveSpeechBubbles(nowMs = performance.now()): boolean {
  let hasActive = false;
  for (const [key, entry] of entries.entries()) {
    if (entry.expiresAtMs <= nowMs) {
      entries.delete(key);
      continue;
    }
    hasActive = true;
  }
  return hasActive;
}

export function subscribeToSpeechBubbleUpdates(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
